/** @jsx h */
import { h } from 'preact'
import Placeholder from '../images/Placeholder'
import ProofPointStatus from '../ProofPointStatus'

const ModalCardHeader = ({ title, imageUrl, variant, claimStatus }) => {
  const mainWrapper =
    variant === 'user'
      ? 'ModalCardHeader ModalCardHeader--user'
      : 'ModalCardHeader'
  const imageClass = variant === 'user' ? 'Avatar Avatar--small' : ''

  return (
    <section class={mainWrapper}>
      {imageUrl &&
        <div class={variant === 'user' ? '' : 'ModalCardheader-logo'}>
          <img class={imageClass} src={imageUrl} width='80' height='80' alt='' />
        </div>}
      {!imageUrl && variant === 'user' &&
        <div class='ModalCardHeader-logo ModalCardHeader-logo--placeholder'>
          <Placeholder />
        </div>}
      <div class='ModalCardHeader-details'>
        <h2 class='ModalCardHeader-title'>{title}</h2>
        <ProofPointStatus status={claimStatus} />
      </div>
    </section>
  )
}

ModalCardHeader.defaultProps = {
  imageUrl: null,
  variant: null
}

export default ModalCardHeader
